import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import WelcomeMessage from "./welcome-message";
import ActivityStatus from "./activity-status";

const { TabPane } = Tabs

const CampaignSettings = () => {
    const { t, i18n } = useTranslation();

    const [activeKey, setActiveKey] = useState("1");
    const [isCampaign, setIscampaign] = useState();


    useEffect(() => {
        const SelectedApp = JSON.parse(localStorage.getItem('selectedApp'));

        if (SelectedApp.appName == "campaign"&&SelectedApp=="agent") {

            setIscampaign(true);


        } else if (SelectedApp.appName == "coffeeproject") {
            setIscampaign(false)
        }
    })
    const handleTabChange = (key) => {
        setActiveKey(key)
        console.log("KEY", key)
    }


    return (

        <Tabs activeKey={activeKey} onChange={handleTabChange} destroyInactiveTabPane={true}>
            {isCampaign && (<TabPane tab={t("welcomeMessage")} key={2}>
                <WelcomeMessage changeTab={handleTabChange} />
            </TabPane>)}

            <TabPane tab={t("activityDescs")} key={1}>
                <ActivityStatus changeTab={handleTabChange} />
            </TabPane>
        </Tabs>

    )
}


export default CampaignSettings